// Localization helpers for bilingual dynamic content.
// Bilingual leaves are stored as { en, ar }. Legacy plain strings are returned as-is (fallback).

export function isLocalized(v) {
  return (
    v != null && typeof v === "object" && !Array.isArray(v) &&
    ("en" in v || "ar" in v) &&
    Object.keys(v).every((k) => k === "en" || k === "ar")
  );
}

export function L(value, lang = "en") {
  if (value == null) return "";
  if (isLocalized(value)) return value[lang] || value.en || value.ar || "";
  if (typeof value === "object") return ""; // defensive: never return a raw object to React
  return value; // plain legacy string
}

// Recursively convert all localized leaves in an object/array tree to plain strings
// for the given language, so existing render code keeps working unchanged.
export function localizeDeep(node, lang = "en") {
  if (node == null) return node;
  if (isLocalized(node)) return L(node, lang);
  if (Array.isArray(node)) return node.map((n) => localizeDeep(n, lang));
  if (typeof node === "object") {
    const out = {};
    for (const k of Object.keys(node)) out[k] = localizeDeep(node[k], lang);
    return out;
  }
  return node;
}

export function arMissing(value) {
  return isLocalized(value) ? !((value.ar || "").trim()) : false;
}
